import styled from 'styled-components'

export const FormTitle = styled.p`
  font-size: 1.8em;
  margin-top:35px;
  margin-bottom:45px;
  font-style:italic;
  width:80%;
  align-self:center;
  display:flex;

 @media (max-height: 710px) {
  margin-top:20px;
  font-size: 1.4em;
  margin-bottom:25px;
  }
`;